import('./bootstrap.tsx');

if (module.hot) {
  module.hot.accept();
}
